export var getDefaultPeriod = function (availableLimitRevenueRate) {
    return availableLimitRevenueRate && availableLimitRevenueRate.length > 0
        ? availableLimitRevenueRate[availableLimitRevenueRate.length - 1].period.toString()
        : undefined;
};
